// src/common/modal/ConfirmModal.jsx
import Modal from "./Modal";
import Button from "../ui/Button";

/**
 * ConfirmModal (simple)
 * - Uses your existing Modal component so ConfirmModal stays clean.
 *
 * Props:
 * - isOpen: boolean
 * - onClose: () => void
 * - onConfirm: () => void
 * - title: string
 * - message: string | ReactNode
 * - confirmText, cancelText: string
 * - confirmVariant: Button variant for confirm
 * - isLoading: boolean
 */
export default function ConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirm Action",
  message = "Are you sure you want to proceed?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmVariant = "success",
  isLoading = false,
  confirmDisabled = false,
  size = "sm",
}) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size={size}
      footer={
        <>
          <Button type="button" variant="outline" onClick={onClose} disabled={isLoading}>
            {cancelText}
          </Button>

          <Button
            type="button"
            variant={confirmVariant}
            onClick={onConfirm}
            disabled={isLoading || confirmDisabled}
          >
            {isLoading ? "Processing..." : confirmText}
          </Button>
        </>
      }
    >
      {/* message can be text OR JSX */}
      {typeof message === "string" ? (
        <p className="text-sm text-smiles-gray">{message}</p>
      ) : (
        <div className="text-sm text-smiles-gray">{message}</div>
      )}
    </Modal>
  );
}
